// ช่วงวันลาแบบสั้น สำหรับป้ายข้างชื่อนักเรียนในหน้าแจ้งลาของทุกฝ่าย
//
// ป้าย "ลาแล้ว" เฉยๆ ไม่พอ — ครูต้องรู้ว่าลาช่วงไหน ถึงจะตัดสินได้ว่าที่กำลังจะแจ้ง
// เป็นการแจ้งซ้ำหรือเป็นคนละช่วง (server ข้ามเฉพาะช่วงที่คาบเกี่ยวกัน)
// เดิมวันที่อยู่ใน title ของป้ายเท่านั้น ซึ่งบนมือถือไม่มี hover จึงไม่มีทางเห็น
//
// ใช้รูปแบบตัวเลข วว/ดด เพราะหน้าแจ้งลาภาคศาสนาสลับภาษาไทย/ยาวีได้
// รับวันที่รูปแบบ 'YYYY-MM-DD' (ทุก endpoint คืนค่าผ่าน DATE_FORMAT มาแล้ว)
const dm = (iso) => {
  if (!iso || typeof iso !== 'string') return '';
  const [, m, d] = iso.split('-');
  return m && d ? `${d}/${m}` : iso;
};

// วันเดียว → "08/09"  ช่วงหลายวัน → "08/09-10/09"
export const leaveRangeShort = (start, end) => {
  const s = dm(start);
  const e = dm(end);
  if (!s) return e;
  if (!e || s === e) return s;
  return `${s}-${e}`;
};

export default leaveRangeShort;
